/**
 * Blueprint for Input fields.
 * @param {string} id id
 * @param {string|number} value value
 * @param {string} type type
 * @param {boolean} required required
 * @param {string} label label
 * @param {string} subtitle subtitle
 * @param {string} placeholder placeholder
 * @param {string} prefixSpan prefix span
 * @constructor
 */
const InputField = function(
  id,
  value,
  type,
  required,
  label,
  subtitle = "",
  placeholder = "",
  prefixSpan
) {
  return {
    id,
    value,
    type,
    required,
    label,
    subtitle,
    placeholder,
    prefixSpan
  };
};

export default InputField;
